<template>
  <b-sidebar
    sidebar-class="w-100 w-xl-75 w-xxl-50"
    lazy backdrop shadow
    id="jobs-sidebar"
    title=""
    right>
    <b-tabs class="h-90" nav-class="mb-0 bg-aba-secondary" no-nav-style content-class="h-100">
      <b-tab active title-link-class="text-white" class="h-100">
        <template #title>
          <b-icon icon="info-circle-fill" scale="0.8" />
          <span class="d-none d-md-inline ml-1">Stellenangebot</span>
        </template>
        <b-overlay :show="iframeLoad" rounded="sm" class="h-100">
          <div class="bg-light h-100 d-flex flex-column">
            <div class="flex-grow-1">
              <template v-if="urlIframe">
                <iframe
                  title="job-iframe"
                  :src="urlIframe"
                  width="100%"
                  height="100%"
                  @load="iframeLoad = false"
                  frameborder="0"
                  id="job-iframe"
                  ref="job-iframe"
                  allowfullscreen
                ></iframe>
              </template>
              <template v-else>
                <iframe
                  title="job-iframe"
                  :src="
                    `${url}/ang/showangex.php?token=${accessTokenApplicant ||
                      accessTokenConsultant ||
                      accessTokenCompany}&sid=${languageSid}&jobnews=1&idang=${jobId}${shortView}`
                  "
                  width="100%"
                  height="100%"
                  @load="iframeLoad = false"
                  frameborder="0"
                  id="job-iframe"
                  ref="job-iframe"
                  allowfullscreen
                ></iframe>
              </template>
            </div>
          </div>
        </b-overlay>
      </b-tab>
      <b-tab lazy title-link-class="text-white">
        <template #title>
          <b-icon icon="building" scale="0.8" />
          <span class="d-none d-md-inline ml-1">{{ jobCompany }}</span>
        </template>
        <div class="component-widget p-3">
          <company-info />
        </div>
      </b-tab>
      <b-tab title-link-class="text-white">
        <template #title>
          <b-icon icon="list-task" scale="0.8" />
          <span class="d-none d-md-inline ml-1">weitere Stellen des Unternehmens</span>
        </template>
        <div class="component-widget p-3">
          <job-company-component :company="jobCompany" />
        </div>
      </b-tab>
    </b-tabs>
  </b-sidebar>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { ProfessionModule } from '@/store/modules/profession';
import CompanyInfo from '@/components/Company/CompanyInfo.vue';
import { ClustersModule } from '@/store/modules/clusters';
import JobCompanyComponent from '@/components/Company/JobCompanyComponent.vue';

const URL = {
  DEFAULT_ANALYSE_PRODUCTION_URL: '/jobnet',
  DEFAULT_ANALYSE_DEVELOPMENT_URL: 'https://test14.job-server.net/jobnet',
};

@Component({
  components: {
    CompanyInfo,
    JobCompanyComponent,
  },
})
export default class JobsSidebar extends Vue {
  iframeLoad = true;

  get languageSid() {
    return AppModule.languageSid;
  }

  get jobId() {
    return ProfessionModule.jobId;
  }

  get urlIframe() {
    return ClustersModule.urlIframe;
  }

  get jobCompany() {
    return ProfessionModule.jobFirm;
  }

  get jobLocation() {
    return ProfessionModule.jobLocation;
  }

  get shortView() {
    return ProfessionModule.shortView.length ? '&no_header_sv=1' : '';
  }

  get url() {
    return process.env.NODE_ENV === 'production'
      ? URL.DEFAULT_ANALYSE_PRODUCTION_URL
      : URL.DEFAULT_ANALYSE_DEVELOPMENT_URL;
  }

  // TokenApplicant
  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  // TokenConsultant
  get accessTokenConsultant() {
    return UserModule.accessTokenConsultant;
  }

  // TokenCompany
  get accessTokenCompany() {
    return UserModule.accessTokenCompany;
  }
}
</script>
